import {Action} from "redux";
import {
	CommunicationsMessageFiltersAction, isCommunicationsMessageFiltersAction
} from "./actions";
import {MessageId, OpenedStatus, SentStatus} from "./data";

export type State = {
	selectedMessages: MessageId[]
	sentStatus: SentStatus
	openedStatus: OpenedStatus
}

export const reducer = (s: State, a: Action): State => {
	if(isCommunicationsMessageFiltersAction(a)) {
		return communicationsMessageFiltersReducer(s, a.action)
	}
	return s
}

const communicationsMessageFiltersReducer = (s: State, a: CommunicationsMessageFiltersAction): State => {
	switch (a.type) {
		case "set messages":
			const numMessages = a.messages.length
			return {
				...s,
				selectedMessages: a.messages,
				sentStatus: numMessages ? s.sentStatus : 'any',
				openedStatus: numMessages ? s.openedStatus : 'any'
			}
		case "set sent status":
			return {...s, sentStatus: a.sentStatus}
		case "set opened status":
			return {...s, openedStatus: a.openedStatus}
	}
}



// WEBPACK FOOTER //
// ./src/contacts/querybuilder-filters/communications-message/reducers.ts